import { render, staticRenderFns } from "./listanggaran.vue?vue&type=template&id=299cf962&"
import script from "./listanggaran.vue?vue&type=script&lang=js&"
export * from "./listanggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports